import { render } from "./HomeAbout.vue?vue&type=template&id=317b10de&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"

import "./HomeAbout.vue?vue&type=style&index=0&id=317b10de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317b10de"]])

export default __exports__